import { createStyles } from '@mantine/styles';
var useStyles = createStyles(function () {
  return {
    root: {}
  };
});
export default useStyles;